var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7856 1.00031C17.301 1.00704 15.8835 1.13228 14.6364 1.35074C10.9619 1.99297 10.2948 3.3367 10.2948 5.8153V9.0886H18.9779V10.1796H7.03585C4.51238 10.1796 2.30241 11.68 1.6113 14.534C0.813977 17.8054 0.778677 19.8467 1.6113 23.2626C2.22857 25.8052 3.70275 27.6169 6.22622 27.6169H9.21182V23.6931C9.21182 20.8583 11.6916 18.3579 14.6364 18.3579H23.3095C25.7238 18.3579 27.6511 16.3918 27.6511 13.9936V5.81498C27.6511 3.48756 25.6658 1.73896 23.3095 1.35042C21.8175 1.10506 20.2701 0.993266 18.7856 1.00031ZM14.0897 3.63267C14.9868 3.63267 15.719 4.36907 15.719 5.27428C15.719 6.17629 14.9865 6.90597 14.0897 6.90597C13.1897 6.90597 12.4604 6.17661 12.4604 5.27428C12.4604 4.36907 13.1897 3.63267 14.0897 3.63267Z",
    fill: "url(#paint0_linear_10225_16198)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7339 10.1797V13.9934C28.7339 16.9502 26.1994 19.4387 23.3094 19.4387H14.6363C12.2605 19.4387 10.2947 21.4497 10.2947 23.803V31.981C10.2947 34.3087 12.3408 35.6778 14.6363 36.3453C17.3848 37.1448 20.0206 37.2893 23.3094 36.3453C25.4954 35.7194 27.651 34.4593 27.651 31.981V28.708H18.9778V27.617H31.9925C34.5163 27.617 35.4565 25.8758 36.3341 23.2627C37.2409 20.5726 37.2024 17.9851 36.3341 14.5341C35.7104 12.0494 34.5192 10.1797 31.9925 10.1797H28.7339ZM23.8557 30.89C24.7557 30.89 25.485 31.6194 25.485 32.5217C25.485 33.4269 24.7557 34.1633 23.8557 34.1633C22.9586 34.1633 22.2264 33.4269 22.2264 32.5217C22.2264 31.6197 22.959 30.89 23.8557 30.89Z",
    fill: "url(#paint1_linear_10225_16198)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10225_16198",
    x1: 0.1436,
    y1: 2.02243,
    x2: 19.9816,
    y2: 19.1117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A9FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#306998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10225_16198",
    x1: 27.6801,
    y1: 29.4162,
    x2: 20.6004,
    y2: 19.3868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD43B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE873"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.e7de37cf72b3ff030de9f4fcc3c287e3.svg";
export { ForwardRef as ReactComponent };